import noteTransposer from './NoteTransposer';
import type { ParsedChord } from './ChordParser';

// Takes a parsed object from ChordParser, and transposes the chord_root and accidental to a new key
class ParsedChordTransposer {
  transpose = (from_key: string, to_key: string, orig_parsed_chord: ParsedChord): ParsedChord => {
    const transposed: ParsedChord = structuredClone(orig_parsed_chord);

    if (
      !transposed.chord_root ||
      from_key === to_key ||
      orig_parsed_chord.type === 'non_chord' ||
      orig_parsed_chord.chord_root === null
    ) {
      return orig_parsed_chord;
    }

    const orig_note = `${orig_parsed_chord.chord_root}${orig_parsed_chord.accidental || ''}`;
    const transposed_note = noteTransposer.transpose(from_key, to_key, orig_note);

    if (!transposed_note) return orig_parsed_chord;

    const parts = transposed_note.split('');
    transposed.chord_root = parts[0] ?? null;
    transposed.accidental = parts[1] ?? null;
    transposed.base_note_raw = orig_parsed_chord.base_note_raw
      ? noteTransposer.transpose(from_key, transposed_note, orig_parsed_chord.base_note_raw)
      : null;

    return transposed;
  };
}

export default new ParsedChordTransposer();
